import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Frequency';
const ENDPOINT = `/frequencies/`;

@Injectable({
    providedIn: 'root'
})
export class FrequencyService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
